
  <ng-container *ngIf="isLoggedIn(); else unauthenticated">
    <app-layouts></app-layouts>
  </ng-container>
  
  <ng-template #unauthenticated>
    <app-landing-layouts></app-landing-layouts>
  </ng-template>
  